import axios from 'axios'

const SERVICE_OAUTH_URL = process.env.GATSBY_URL_BASE_OAUTH

const CLIENT_ID = process.env.GATSBY_OAUTH_CLIENT_ID
const SECRET_ID = process.env.GATSBY_OAUTH_CLIENT_SECRET
const SCOPE_AHORROYA = process.env.GATSBY_OAUTH_SCOPE_AHORROYA
const SCOPE_ESTABLISHMENT = process.env.GATSBY_OATUH_SCOPE_ESTABLISHMENT
const SCOPE_APV = process.env.GATSBY_OAUTH_SCOPE_APV
const SUBSCRIPTION_KEY = process.env.GATSBY_SUBSCRIPTION_KEY_OAUTH
const SCOPE_BOOK = process.env.GATSBY_OATUH_SCOPE_BOOK

export async function getAccessToken(type) {
  try {
    // Crear el cuerpo de la petición en formato x-www-form-urlencoded
    const data = new URLSearchParams()
    data.append('client_id', CLIENT_ID)
    data.append('client_secret', SECRET_ID)
    switch (type) {
      case 'ahorroya':
        data.append('scope', SCOPE_AHORROYA)
        break
      case 'establishment':
        data.append('scope', SCOPE_ESTABLISHMENT)
        break
      case 'goalsaccount':
        data.append('scope', SCOPE_APV)
        break
      case 'book':
        data.append('scope', SCOPE_BOOK)
        break
    }
    // Realizar la petición con el cuerpo y el header adecuado
    const response = await axios.post(SERVICE_OAUTH_URL, data, {
      headers: { 
        'Content-Type': 'application/x-www-form-urlencoded',
        'Ocp-Apim-Subscription-Key': SUBSCRIPTION_KEY
      },
    })
    const accessToken = response.data.access_token
    localStorage.setItem('access_token', accessToken)
    return accessToken
  } catch (error) {
    console.error(error)
  }
}


